<template>
    <div class="list--view responsive-element">

        <div data-toggle="tooltip" data-placement="top" title="Filtra per anagrafiche attive o storiche"
            class="single--list-view single--list-view-employees">
            <span class="pre-filter-label"> Filtri</span>
            <vs-select class="selectExample" v-model="selectTypePerson" @input="statusSelected">
                <vs-select-item :is-selected="item.isSelected" :key="index" :value="item.value" :text="item.label"
                    v-for="(item, index) in optionsTypePerson" />
            </vs-select>
        </div>

        <!-- Contractual Item Filter - Only visible if configuration is enabled -->
        <div v-if="advancedFiltersEnabled" data-toggle="tooltip" data-placement="top" title="Filtra per voce contrattuale"
            class="single--list-view single--list-view-roles">
            <vs-select class="selectExample" v-model="selectContractualItem" @input="contractualItemSelected">
                <vs-select-item :is-selected="item.isSelected" :key="index" :value="item.value" :text="item.label"
                    v-for="(item, index) in optionsContractualItems" />
            </vs-select>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                selectTypePerson: this.getSelectedTypePerson(),
                optionsTypePerson:[

                    {value: '0', label: this.__("misc.actuals"), isSelected: true },
                    {value: '1', label: this.__("misc.history"), isSelected: false },
                ],
                selectContractualItem: this.getSelectedContractualItem(),
                optionsContractualItems: [],
                advancedFiltersEnabled: false,
            }
        },
        methods: {
          getSelectedTypePerson(){
            let closedValue = '0';
            if (location.search.indexOf("closed") >= 0 ){
              closedValue = (/closed=([^&]+)/.exec(location.href)[1] === "true") ? '1' : '0';
            }
            return closedValue;
          },
          getSelectedContractualItem(){
            let contractualItemValue = '';
            if (location.search.indexOf("contractual_item_id") >= 0 ){
              contractualItemValue = /contractual_item_id=([^&]+)/.exec(location.href)[1];
            }
            return contractualItemValue;
          },
          statusSelected(selectedOption, id) {

              if (selectedOption === 'all') {
                location.href = app.__vue__.removeParam("closed");
              } else if (selectedOption == "1") {
                location.href = app.__vue__.addParam("closed", "true");
              } else if (selectedOption == "0") {
                  location.href = app.__vue__.addParam("closed", "false");
              }
            },
          contractualItemSelected(selectedOption, id) {
              if (selectedOption) {
                location.href = app.__vue__.addParam("contractual_item_id", selectedOption);
              }
          },
          loadContractualItems(){
              axios
                  .get("/api/contractual-items-people/get-contractual-items" + location.search)
                  .then(response => {
                      this.optionsContractualItems = response.data;
                      // Auto-select first item if none selected
                      if (!this.selectContractualItem && this.optionsContractualItems.length > 0) {
                          this.selectContractualItem = this.optionsContractualItems[0].value;
                      }
                  });
          }
        },
        mounted(){
            // Carica il flag advancedFiltersEnabled tramite API
            axios.get('/api/config/advanced-historical-filters')
                .then(response => {
                    this.advancedFiltersEnabled = !!response.data.advancedHistoricalFilters;
                    if (this.advancedFiltersEnabled) {
                        this.loadContractualItems();
                    }
                })
                .catch(() => {
                    this.advancedFiltersEnabled = false;
                });
        }

    }
</script>
